// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/" + ({"2": "profiler","586": "recorder",}[chunkId] || chunkId) + "." + {"118": "227bbb3a","183": "5d12dfbe","2": "3c03d8a0","33": "fc43c9f1","563": "69201cdb","586": "a8f16312","621": "eb9f3a11","810": "fba8f6f7","857": "2de31704",}[chunkId] + ".chunk.js"
}